
import {
  computed, defineComponent, PropType,
} from 'vue';
import DataSourceTreeSelect from '@/components/fields/DataSourceTreeSelect.vue';
import { DataSourceOption } from '@/composables/data-sources/dataSourceTree';

/**
 * Filtre « Points de vente » d'une page de statistiques, présenté comme le
 * sélecteur du header. La valeur enregistrée est vide quand tous les points de
 * vente sont cochés, ou aucun : le widget compte alors toutes les sources.
 */
export default defineComponent({
  name: 'DataSourceFilterSelect',

  components: { DataSourceTreeSelect },

  props: {
    modelValue: {
      type: [Array, Number, String] as PropType<number[] | number | string>,
      default: () => [],
    },

    options: {
      type: Array as PropType<DataSourceOption[]>,
      default: () => [],
    },

    dataKey: {
      type: String,
      default: 'value',
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const allIds = computed(() => props.options.map((option) => option.value));

    const savedIds = computed<number[]>(() => {
      const values = Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue];
      return values
        .filter((value) => value !== '' && value !== null && value !== undefined)
        .map((value) => Number(value))
        .filter((value) => Number.isInteger(value) && value > 0);
    });

    // Rien d'enregistré : tout est coché, comme dans le header.
    const selection = computed(() => (savedIds.value.length ? savedIds.value : allIds.value));

    const onUpdate = (ids: number[]) => {
      const everything = ids.length === 0 || allIds.value.every((id) => ids.includes(id));
      emit('update:modelValue', everything ? [] : ids);
    };

    return {
      selection,
      onUpdate,
    };
  },
});
